module.exports = __webpack_public_path__ + "img/omega-1-procedimental.7c30b26b.png";